const { isEmpty } = require('lodash');

const { prefectures, } = require('../config');

const { entries } = Object;

module.exports = {
  fields: () => {
    return {
      name: {
        type: 'string',
        label: '識別名',
        validations: {
          required: v => !isEmpty(v),
        },
      },
    };
  },
};
